import styled, { css } from 'styled-components';

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;

  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const ProductName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.bold};


    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.md};
    }
  `}
`;

export const PlanInfo = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}

  button:disabled svg {
    fill: none;
  }
`;
